import { RouteLocationRaw } from 'vue-router'

export type WizardType = 'new'

export enum InsightsReportsRoute {
  HOME = 'home',
  ASK = 'ask',
  NEW = 'new',
  SETTINGS = 'settings',
  MY_REPORTS = 'reports',
  MY_REPORTS_WIZARD_CONFIG = 'config',
  MY_REPORTS_WIZARD_TYPE = 'type',
  MY_REPORTS_WIZARD_FILTERS = 'filters',
  MY_REPORTS_WIZARD_REVIEW = 'review',
  MY_DASHBOARD = 'dashboard',
  MY_SURVEY_PRODUCTS = 'survey-products',
  MY_SURVEYS_SURVEY = 'survey-type',
  MY_SURVEYS_SUMMARY = 'survey-summary',
  TRAINING_IMPACT = 'training-impact',
  TRAINING_IMAPCT_PRODUCTS = 'training-impact-products',
  REAL_TALK_DASHBOARD = 'real-talk-dashboard',
  FAST_EXAM_DASHBOARD = 'fast-exam-dashboard',
  FAST_EXAM_DASHBOARD_PRODUCTS = 'fast-exam-dashboard-products',
}

export const myReportsRoute: RouteLocationRaw = {
  name: InsightsReportsRoute.MY_REPORTS,
}

export const createHomeRoute: RouteLocationRaw = {
  name: InsightsReportsRoute.HOME,
}

export const createMyReportsWizardRoute = (
  wizardType: WizardType,
  reportId: string
): RouteLocationRaw => ({
  name: InsightsReportsRoute.MY_REPORTS_WIZARD_TYPE,
  params: {
    wizardType,
    reportId,
  },
})
